/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MenuOrderStatus } from './MenuOrderStatus';
import {
    MenuOrderStatusFromJSON,
    MenuOrderStatusFromJSONTyped,
    MenuOrderStatusToJSON,
    MenuOrderStatusToJSONTyped,
} from './MenuOrderStatus';

/**
 * 
 * @export
 * @interface MenuOrderLog
 */
export interface MenuOrderLog {
    /**
     * 
     * @type {number}
     * @memberof MenuOrderLog
     */
    date: number;
    /**
     * 
     * @type {MenuOrderStatus}
     * @memberof MenuOrderLog
     */
    status: MenuOrderStatus;
}



/**
 * Check if a given object implements the MenuOrderLog interface.
 */
export function instanceOfMenuOrderLog(value: object): value is MenuOrderLog {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MenuOrderLogFromJSON(json: any): MenuOrderLog {
    return MenuOrderLogFromJSONTyped(json, false);
}

export function MenuOrderLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderLog {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'status': MenuOrderStatusFromJSON(json['status']),
    };
}

export function MenuOrderLogToJSON(json: any): MenuOrderLog {
    return MenuOrderLogToJSONTyped(json, false);
}

export function MenuOrderLogToJSONTyped(value?: MenuOrderLog | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'status': MenuOrderStatusToJSON(value['status']),
    };
}

